var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { getAppUserAgentInfo } from '@saturn/ua-parser';
/**
 * 定义业务错误模型
 */
var ServiceError = /** @class */ (function (_super) {
    __extends(ServiceError, _super);
    /**
     *
     * @param code 业务错误代码
     * @param message 业务错误消息
     */
    function ServiceError(code, message) {
        var _this = _super.call(this) || this;
        _this.code = code;
        _this.message = message;
        _this.name = 'ServiceError';
        return _this;
    }
    return ServiceError;
}(Error));
export { ServiceError };
/**
 * 定义基础请求函数
 * @param this Service实例
 * @param arg1 基础请求配置
 * @param arg2 请求参数(可选)
 * @returns 根据参数返回请求结果或者请求函数
 */
var request = function (arg1, arg2) {
    var _this = this;
    var isPOST = arg1.method === 'post' || arg1.method === 'POST';
    if (arg2 !== undefined) {
        //给定了第二个参数，直接请求
        return this.axios(__assign(__assign({}, arg1), { params: arg2, data: isPOST ? arg2 : undefined }));
    }
    else {
        //没有第二个参数，返回请求函数
        return function (params) {
            return _this.axios(__assign(__assign({}, arg1), { params: params, data: isPOST ? params : undefined }));
        };
    }
};
/**
 * 定义简单GET请求函数
 * @param this Service实例
 * @param arg1 简单请求配置或者请求url
 * @param arg2 请求参数(可选)
 * @returns 根据参数类型返回结果或者请求函数
 */
var get = function (arg1, arg2) {
    if (typeof arg1 === 'string') {
        //参数为url字符串
        return this.request({ url: arg1, method: 'GET' }, arg2);
    }
    else {
        return this.request(__assign(__assign({}, arg1), { method: 'GET' }), arg2);
    }
};
/**
 * 定义简单POST请求函数
 * @param this Service实例
 * @param arg1 简单请求配置或者请求url
 * @param arg2 请求参数(可选)
 * @returns 根据参数类型返回结果或者请求函数
 */
var post = function (arg1, arg2) {
    if (typeof arg1 === 'string') {
        //参数为url字符串
        return this.request({ url: arg1, method: 'POST' }, arg2);
    }
    else {
        return this.request(__assign(__assign({}, arg1), { method: 'POST' }), arg2);
    }
};
/**
 *
 * @param this Service实例
 * @param params 服务初始化配置
 * @returns 初始化后的Service实例
 */
var init = function (params) {
    return __awaiter(this, void 0, void 0, function () {
        var sessionid, host, env, requestInterceptor, legacyRequestInterceptor, responseInterceptor, errorInterceptor, legacyResponseInterceptor, p, appName, query, _a, app, ua, uaInterceptor;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sessionid = params.sessionid, host = params.host, env = params.env;
                    //定义基础请求及下级请求的BaseURL
                    this.axios.defaults.baseURL = env === 'qa' ? '/gateway/h5' : '/h5';
                    this.appcore.axios.defaults.baseURL = '/appcore';
                    this.legacy.appgw.axios.defaults.baseURL =
                        env === 'prod' ? '/appgw/v2' : '/appgw';
                    this.legacy.activity.axios.defaults.baseURL = {
                        prod: '/v2/agservice/activity',
                        dev: '/activity',
                        qa: '/support/interface/activity'
                    }[env];
                    this.legacy.annual.axios.defaults.baseURL = {
                        prod: '/activity/annual',
                        dev: '/annual',
                        qa: '/gateway/activity/annual'
                    }[env];
                    requestInterceptor = function (config) {
                        var sid = typeof sessionid === 'string' ? sessionid : sessionid();
                        if (sid)
                            config.headers['EL-AUTH'] = sid;
                        config.headers['EL-HOST'] = host;
                        return config;
                    };
                    this.axios.interceptors.request.use(requestInterceptor);
                    this.appcore.axios.interceptors.request.use(requestInterceptor);
                    legacyRequestInterceptor = function (config) {
                        var sid = typeof sessionid === 'string' ? sessionid : sessionid();
                        if (sid)
                            config.params = __assign(__assign({}, config.params), { sessionid: sid });
                        config.headers['EL-HOST'] = host;
                        return config;
                    };
                    this.legacy.appgw.axios.interceptors.request.use(legacyRequestInterceptor);
                    this.legacy.activity.axios.interceptors.request.use(legacyRequestInterceptor);
                    this.legacy.annual.axios.interceptors.request.use(function (config) {
                        var sid = typeof sessionid === 'string' ? sessionid : sessionid();
                        if (sid) {
                            config.headers['EL-AUTH'] = sid;
                            config.params = __assign(__assign({}, config.params), { sessionId: sid });
                        }
                        config.headers['EL-HOST'] = host;
                        return config;
                    });
                    responseInterceptor = function (res) {
                        return res.data;
                    };
                    errorInterceptor = function (err) {
                        if (!err.response)
                            throw err;
                        var _a = err.response.data, code = _a.code, message = _a.message;
                        throw new ServiceError(code, message);
                    };
                    this.axios.interceptors.response.use(responseInterceptor, errorInterceptor);
                    this.appcore.axios.interceptors.response.use(responseInterceptor, errorInterceptor);
                    legacyResponseInterceptor = function (res) {
                        var _a = res.data, retval = _a.retval, retinfo = _a.retinfo, reterr = _a.reterr;
                        if (retval === 'ok')
                            return retinfo;
                        throw new ServiceError(retval, reterr);
                    };
                    this.legacy.appgw.axios.interceptors.response.use(legacyResponseInterceptor);
                    this.legacy.activity.axios.interceptors.response.use(legacyResponseInterceptor);
                    this.legacy.annual.axios.interceptors.response.use(responseInterceptor, errorInterceptor);
                    p = new URLSearchParams(window.location.search);
                    appName = p.get('appName') || p.get('appname');
                    query = params.env === 'prod' && appName ? { appName: appName } : null;
                    _a = this;
                    return [4 /*yield*/, this.get('/general/app/info', query)];
                case 1:
                    _a.info = _b.sent();
                    app = getAppUserAgentInfo();
                    if (app)
                        return [2 /*return*/, this]; //在APP内部，跳过构造H5 UA
                    if (params.env !== 'prod' && appName) {
                        this.info.appName = appName;
                    }
                    ua = "".concat(this.info.appName, " v6.11.0 rv:20230803 ").concat(params.env === 'prod' ? 'Online' : 'Development', " (h5) ").concat(navigator.userAgent);
                    uaInterceptor = function (config) {
                        config.headers['Custom-Agent'] = ua;
                        return config;
                    };
                    this.axios.interceptors.request.use(uaInterceptor);
                    this.appcore.axios.interceptors.request.use(uaInterceptor);
                    this.legacy.appgw.axios.interceptors.request.use(uaInterceptor);
                    this.legacy.activity.axios.interceptors.request.use(uaInterceptor);
                    this.legacy.annual.axios.interceptors.request.use(uaInterceptor);
                    return [2 /*return*/, this];
            }
        });
    });
};
var createInstance = function () {
    var ctx = new Object();
    var instance = request.bind(ctx);
    var axiosInstance = axios.create();
    instance.axios = axiosInstance;
    instance.request = request.bind(instance);
    instance.get = get.bind(instance);
    instance.post = post.bind(instance);
    instance.init = init.bind(instance);
    instance.legacy = {
        appgw: createSubInstance(),
        activity: createSubInstance(),
        annual: createSubInstance()
    };
    instance.appcore = createSubInstance();
    return instance;
};
var createSubInstance = function () {
    var ctx = new Object();
    var instance = request.bind(ctx);
    var axiosInstance = axios.create();
    instance.axios = axiosInstance;
    instance.request = request.bind(instance);
    instance.get = get.bind(instance);
    instance.post = post.bind(instance);
    return instance;
};
var service = createInstance();
export default service;
